import React, { useEffect } from 'react';
import 'leaflet/dist/leaflet.css';
import { MapContainer, TileLayer, ZoomControl } from 'react-leaflet';
import { NCA_MAP_URL } from '@constants';
import useAmplitude from '@hooks/useAmplitude';
import { MapPropsInterface } from './MapContainerType';
import Markers from './Markers';
import EmptyState from './EmptyState';
import ControlFromOutsideCenterMap from './ControlFromOutsideCenterMap';

function Map({ markers }: MapPropsInterface) {
  const { amplitudeEvent } = useAmplitude();
  const markersWithLocation = markers.filter((pin) =>
    Boolean(pin.coordinates[0] && pin.coordinates[1]),
  );
  const positionsToCenterMap = markersWithLocation.map(
    (pin) => pin.coordinates as [number, number],
  );

  useEffect(() => {
    amplitudeEvent('journey_list_map_viewed');
  }, []);

  function renderMap() {
    if (!markersWithLocation.length) {
      return <EmptyState />;
    }

    return (
      <MapContainer
        attributionControl={false}
        bounds={positionsToCenterMap}
        zoomControl={false}
        scrollWheelZoom
        className="map"
      >
        <TileLayer
          url={`${NCA_MAP_URL}styles/journeys/{z}/{x}/{y}.png`}
          maxZoom={16}
          minZoom={4}
        />
        <Markers markers={markersWithLocation} />
        <ZoomControl position="bottomright" />
        <ControlFromOutsideCenterMap />
      </MapContainer>
    );
  }

  return <>{renderMap()}</>;
}

export default Map;
